/**
 * @file Provides utility methods to support interacting with the VTC Accounts API
 * @author Joshua Jack <jjack@redhat.com>
 */

import { get } from 'axios';

import { VTC_ACCOUNTS_API } from '../config/constants';

/**
 * Returns VTC Accounts
 * @return {Object} A collection of VTC Accounts
 */
const getVTCAccounts = () =>
  new Promise((resolve, reject) => {
    get(VTC_ACCOUNTS_API)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });

export { getVTCAccounts };
export default getVTCAccounts;
